import * as React from 'react'
import { PlayerRank } from '../../reducers/statsRanking'
import('./PlayerInfoRowStyles.scss')   



/*
  An element to display information of a player like player rank, players national flag, players name or players abbreviation.
*/
const PlayerInfoRow = ( props: { rank?: PlayerRank, flagUrl: string, playerName?: string, playerAbbreviationName: string } ) => {
  return (
    <div className="playerInfoRow">
      { props.rank ? <div className="playerInfoRow-rank"> { props.rank.rank } </div> : '' }
      { props.flagUrl ? <div className="playerInfoRow-flag"><img src = { props.flagUrl } /></div> : '' }
      { props.playerName ? <div className="playerInfoRow-name unabbreviated"> { props.playerName } </div> : '' }
      { props.playerAbbreviationName ? <div className="playerInfoRow-name abbreviated"> { props.playerAbbreviationName } </div> : '' }
    </div>
  )
}

export default PlayerInfoRow